import React, { useState, useEffect, useCallback } from 'react';
import '../Cupones/EditarCupones.css';
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Volver } from '../assets/icon/volver.svg';
import CalendarInicio from './CalendarInicio';
import CalendarFin from './CalendarFin';
import { getCuponById, getCatalogoTarjetas, createCupon, updateCupon } from '../services/cupones';
import { useToast } from '../contexts/ToastContext';

function EditarCupones() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { showSuccess, showError } = useToast();
    const isEditMode = Boolean(id);

    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(isEditMode);
    const [empresa, setEmpresa] = useState("");
    const [descuento, setDescuento] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [codigo, setCodigo] = useState("");
    const [idTipoTarjeta, setIdTipoTarjeta] = useState(1);
    const [tiposTarjeta, setTiposTarjeta] = useState([]);

    useEffect(() => {
        if (isEditMode && id) {
            loadCupon(id);
        }
        loadTiposTarjeta();
    }, [id, isEditMode]);

    const loadTiposTarjeta = async () => {
        try {
            const result = await getCatalogoTarjetas();
            if (result.success && result.error === 0 && result.data) {
                setTiposTarjeta(result.data.data || []);
            }
        } catch (error) {
            console.error('Error al cargar tipos de tarjeta:', error);
        }
    };

    const loadCupon = async (cuponId) => {
        setLoadingData(true);
        try {
            const result = await getCuponById(cuponId);
            if (result.success && result.error === 0 && result.data) {
                const cupon = result.data.data;
                setEmpresa(cupon.Empresa || "");
                setDescuento(cupon.PorcentajeDescuento?.toString() || "");
                setFechaFin(cupon.Fecha_fin || "");
                setDescripcion(cupon.Descripcion || "");
                setCodigo(cupon.CodigoPromo || "");
                setIdTipoTarjeta(cupon.IdTipoTarjeta || 1);
            } else {
                showError(result.mensaje || 'Error al cargar el cupón');
                navigate("/dashboard/Cupones");
            }
        } catch (error) {
            showError('Error al cargar el cupón');
            navigate("/dashboard/Cupones");
        } finally {
            setLoadingData(false);
        }
    };

    const validateForm = () => {
        if (!descuento.trim()) {
            showError('El descuento es requerido');
            return false;
        }
        if (!empresa.trim()) {
            showError('La empresa es requerida');
            return false;
        }
        if (!fechaFin) {
            showError('La fecha de fin es requerida');
            return false;
        }
        if (!codigo.trim()) {
            showError('El código es requerido');
            return false;
        }
        if (!idTipoTarjeta) {
            showError('El tipo de tarjeta es requerido');
            return false;
        }
        return true;
    };

    const handleConfirm = async () => {
        if (!validateForm()) return;

        setLoading(true);
        try {
            const cuponData = {
                PorcentajeDescuento: parseFloat(descuento),
                Empresa: empresa,
                Fecha_fin: fechaFin,
                Descripcion: descripcion,
                CodigoPromo: codigo,
                IdTipoTarjeta: idTipoTarjeta
            };

            let result;
            if (isEditMode) {
                result = await updateCupon(id, cuponData);
            } else {
                result = await createCupon(cuponData);
            }

            if (result.success && result.error === 0) {
                showSuccess(isEditMode ? 'Cupón actualizado correctamente' : 'Cupón creado correctamente');
                navigate("/dashboard/Cupones");
            } else {
                showError(result.mensaje || 'Error al guardar el cupón');
            }
        } catch (error) {
            showError('Error al guardar el cupón');
        } finally {
            setLoading(false);
        }
    };

    if (loadingData) {
        return (
            <div className='bodyEditarCupones'>
                <div className="loading-container">
                    <p>Cargando cupón...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='bodyEditarCupones'>

            {/* TÍTULO */}
            <div className='tituloEditarCupones'><p>{isEditMode ? '-Editar Cupón' : '-Nuevo Cupón'}</p></div>

            <div className='cuerpoBotonVolverCupones'>
                <button
                    className='botonesEditarCupones'
                    onClick={() => navigate("/dashboard/Cupones")}
                >
                    <div className="svgBotones"><Volver className="logo-svgBotones" /></div>
                    Volver
                </button>
            </div>

            <div className='cuerpoEditarCupones'>
                <div className='parte1'>
                    {/* INPUT descuento */}
                    <div className="input-groupEditarCupones">
                        <div className='text-inputEditarCupones'>
                            <label htmlFor="descuento">Descuento (%)</label>
                        </div>
                        <input
                            className="inputEditarCupones"
                            type="number"
                            id="descuento"
                            maxLength={20}
                            value={descuento}
                            onChange={(e) => setDescuento(e.target.value)}
                            placeholder="20"
                        />
                        <div className="contador">{descuento.length}/20</div>
                    </div>
                    {/* INPUT empresa */}
                    <div className="input-groupEditarCupones">
                        <div className='text-inputEditarCupones'>
                            <label htmlFor="empresa">Empresa</label>
                        </div>
                        <input
                            className="inputEditarCupones"
                            type="text"
                            id="empresa"
                            maxLength={100}
                            value={empresa}
                            onChange={(e) => setEmpresa(e.target.value)}
                            placeholder="6B Invent Germany"
                        />
                        <div className="contador">{empresa.length}/100</div>
                    </div>
                    {/* calendario */}
                    <div className='calendario'>
                        <CalendarFin onSelect={setFechaFin} value={fechaFin} />
                        <div className="contadorFantasma">0/30</div>
                    </div>
                    
                    <div className="input-groupEditarCupones">
                        <div className='text-inputEditarCupones'>
                            <label htmlFor="idTipoTarjeta">Tipo de Tarjeta</label>
                        </div>
                        <select
                            className="inputEditarCupones"
                            id="idTipoTarjeta"
                            value={idTipoTarjeta}
                            onChange={(e) => setIdTipoTarjeta(parseInt(e.target.value))}
                        >
                            {tiposTarjeta.map((tarjeta) => (
                                <option key={tarjeta.IdTarjeta} value={tarjeta.IdTarjeta}>
                                    {tarjeta.Nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='parte2'>
                    {/* descripcion */}
                    <div className="input-groupEditarCupones">
                        <div className='text-inputEditarCupones'>
                            <label htmlFor="descripcion">Descripcion</label>
                        </div>
                        <textarea
                            className="EditarCuponestextarea"
                            maxLength={80}
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            placeholder="Descripción del cupón"
                            rows={1}
                        />
                        <div className="contador">{descripcion.length}/80</div>
                    </div>
                    {/* INPUT codigo */}
                    <div className="input-groupEditarCupones">
                        <div className='text-inputEditarCupones'>
                            <label htmlFor="codigo">Código</label>
                        </div>
                        <input
                            className="inputEditarCupones"
                            type="text"
                            id="codigo"
                            maxLength={20}
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                            placeholder="VERANO20"
                        />
                        <div className="contador">{codigo.length}/20</div>
                    </div>
                </div>

            </div>
            {/* botones */}
            <div className='botonesEditarCupones2'>
                <button 
                    type="button" 
                    className="btn-acceptConfirmarCupones"
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading ? 'Guardando...' : 'Confirmar'}
                </button>
            </div>
        </div>
    )
}

export default EditarCupones;
